const $ = window.jQuery;

const Clipboard = require('clipboard');

/**
 * Enables 'Share' plugin specific scripting
 */
const Share = {

    /**
     * Initialise functionality
     */
    init()
    {

        // look for elements with data attribute and update text on success
        const clipboard = new Clipboard('a[data-clipboard-text]');
        clipboard.on('success', function(e) {
            $(e.trigger).find('*[data-clipboard-text-label]').text('Copied');
            e.clearSelection();
        });

    },

};

export default Share;